module.exports = __webpack_public_path__ + "static/assets/aa249b12450d4c37c61f7123b03dab3a.gif";